/**
 * PhaseInfo Component
 * Displays the current phase info: display range, subtitle, and description
 * Supports HTML content from TipTap editor
 */

import parse from 'html-react-parser';
import type { BabyDevelopmentPhase } from '../types';

interface PhaseInfoProps {
  phase: BabyDevelopmentPhase | null;
  displayRange: string;
  isLoading?: boolean;
}

// Helper to check if content is HTML
function isHtmlContent(content: string): boolean {
  return /<[a-z][\s\S]*>/i.test(content);
}

export function PhaseInfo({ phase, displayRange, isLoading }: PhaseInfoProps) {
  if (isLoading) {
    return (
      <div className="animate-pulse text-center">
        <div className="h-5 bg-white/10 rounded w-24 mb-2 mx-auto" />
        <div className="h-6 bg-white/10 rounded w-48 mb-3 mx-auto" />
        <div className="h-4 bg-white/10 rounded w-full" />
        <div className="h-4 bg-white/10 rounded w-3/4 mt-2 mx-auto" />
      </div>
    );
  }

  return (
    <div className="text-center">
      {/* Phase Display Range */}
      <div className="text-white/75 text-sm mb-1">
        {displayRange}
      </div>

      {/* Phase Subtitle */}
      {phase?.subtitle && (
        <h2 className="text-white text-xl font-bold mb-3">
          {phase.subtitle}
        </h2>
      )}

      {/* Phase Description */}
      {phase?.description && (
        isHtmlContent(phase.description) ? (
          <div className="prose prose-sm prose-invert max-w-none prose-p:text-white/70 prose-p:leading-relaxed prose-p:my-1">
            {parse(phase.description)}
          </div>
        ) : (
          <p className="text-white/70 text-sm leading-relaxed">
            {phase.description}
          </p>
        )
      )}
    </div>
  );
}
